import { instance } from 'services';
import {
  IFindFnReturn,
  IGenericPayload,
  IGenericResource,
  IQueryParams,
  IResponse,
} from 'services/types.d';

export const CompanyStageResources = {
  findAll: (p?: IQueryParams): Promise<IFindFnReturn<IGenericResource>> =>
    instance.get('/company-stage/', { params: p }),

  create: (params: IGenericPayload): Promise<IResponse<IGenericResource>> =>
    instance.post(`/company-stage/`, params),

  update: (
    id: number,
    params: IGenericPayload,
  ): Promise<IResponse<IGenericResource>> =>
    instance.patch(`/company-stage/${id}/`, params),

  delete: (id: number): Promise<IResponse<unknown>> =>
    instance.delete(`/company-stage/${id}/`),
};
